module.exports = __webpack_public_path__ + "votolegal--e9946c90.png";


//////////////////
// WEBPACK FOOTER
// ./_source/img/logo/votolegal.png
// module id = 94
// module chunks = 0